import React, { useMemo, useRef, useState, useEffect, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import SearchBar from "../../../../SearchBarTable/SearchBarTable";
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-grid.css";
// @ts-ignore CSS is loaded by the application bundler.
import "ag-grid-community/styles/ag-theme-alpine.css";
import { FaSort, FaEdit, FaTrashAlt, FaBuilding, FaCubes } from 'react-icons/fa';
// import CustomFloatingFilter from "../../../EntitlementsSetup/CustomFloatingFilter";
// @ts-ignore CSS is loaded by the application bundler.
import "../../../AgGridTheme.css";
import SortHeader from "../../../SortingHeader";

import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule
} from "ag-grid-community";
import { Users } from "lucide-react";
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);

interface UserGroupTableProps {
  userGroups: any[];
  selectedRow: string | null;
  onRowSelect: (userGroup: any) => void;
  onClearSelection: () => void;
  // onEditUserGroup: (userGroupId: string, updatedUserGroup: any) => void;
  onEditUserGroup: (userGroupId: number, updatedUserGroup: any) => Promise<void>;
}

const UserGroupTable: React.FC<UserGroupTableProps> = ({
  userGroups,
  selectedRow,
  onRowSelect,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "User Group Name",
        field: "user_group_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        autoHeight: true,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'User Group Name',
          enableSorting: true,
          icon: <FaCubes className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },  
      {
        headerName: "Users",
        field: "users",
        sortable: true, 
        flex: 1,
        minWidth: 550,
        // enableRowGroup: true,
        valueFormatter: (params: any) =>
          Array.isArray(params.value) ? params.value.map((u: any) => u.login_name).join(', ') : '',
        cellRenderer: (params: any) => {
          const users = params.value;
          if (!Array.isArray(users) || users.length === 0) return "No Users";
          return (
            <div style={{ whiteSpace: "pre-line", padding: "4px 0" }}>
              {users.map((u: any) => u.login_name).join("\n")}
            </div>
          );
        },
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Users',
          enableSorting: true,
          icon: <FaCubes className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },  

    ],
    []
  );

  const defaultColDef = useMemo(() => ({
    // sortable: true,
    // filter: true,
    // floatingFilter: true,
    resizable: true,
    cellStyle: {
      padding: "8px 12px",
      fontSize: "16px",
      fontFamily: "'Poppins', sans-serif",
      color: "#374151",
    },
  }), []);

  // const filteredUserGroups = useMemo(() => {
  //   if (!searchQuery) return userGroups;
  //   return userGroups.filter((group) => {
  //     const searchLower = searchQuery.toLowerCase().trim();
  //     return Object.values(group).some((value) =>
  //       typeof value === "string"
  //         ? value.toLowerCase().includes(searchLower)
  //         : false
  //     );
  //   });
  // }, [userGroups, searchQuery]);
  // const filteredUserGroups = useMemo(() => {
  //   const lowerSearch = searchQuery.toLowerCase();
  //   return userGroups.filter(group =>
  //     group.user_group_name?.toLowerCase().includes(lowerSearch) ||
  //     // group.company_name?.toLowerCase().includes(lowerSearch) ||
  //     (Array.isArray(group.users) &&
  //       group.users.some((user: any) =>
  //         user.login_name.toLowerCase().includes(lowerSearch)
  //       ))
  //   );
  // }, [userGroups, searchQuery]);
  const filteredUserGroups = useMemo(() => {
    const lowerSearch = searchQuery.toLowerCase();
    return userGroups.filter(group =>
      group.user_group_name?.toLowerCase().includes(lowerSearch) ||
      (Array.isArray(group.users) &&
        group.users.some((user: any) =>
          user.login_name.toLowerCase().includes(lowerSearch)
        ))
    );
  }, [userGroups, searchQuery]);
  

  // const handleRowClicked = (event: any) => {
  //   onRowSelect(event.data);
  // };


  const handleRowClicked = useCallback((event: any) => {
    onRowSelect(event.data);
  }, [onRowSelect]);

  useEffect(() => {
    if (gridRef.current && selectedRow !== null) {
      gridRef.current.api.forEachNode((node) => {
        // node.setSelected(node.data.asset_group_id === selectedRow);
        node.setSelected(node.data.user_group_name === selectedRow);
      });
    }
  }, [selectedRow]);

  return (
    // <div className="flex-1 bg-white p-5 rounded-xl shadow-md font-poppins h-full">
    <div className="p-4 bg-white shadow-md rounded-xl font-poppins">
    <div className="flex justify-between items-center mb-4">
    <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
      {/* <div className="flex justify-between items-center space-x-4 mb-6"> */}
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search Users Group..."
        />
      {/* </div> */}
      </div>
      </div>

      <div
        className="ag-theme-alpine font-poppins text-base text-gray-700"
        style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", width: "100%",overflow:'auto', border: '1px solid #E7E4FF', borderRadius: '8px' }}
      >
        <AgGridReact
          theme="legacy"
          ref={gridRef}
          rowData={filteredUserGroups}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={{ mode: 'singleRow' }}
          onGridReady={(params) => setGridApi(params.api)}
          onRowClicked={handleRowClicked}
          domLayout="normal"
          pagination={true}
          rowHeight={60}
          headerHeight={55}
          // paginationPageSize={15}
          suppressRowHoverHighlight={false}
          className="ag-theme-alpine"
          // suppressRowClickSelection={false}
          // suppressCellFocus={true}
          getRowHeight={(params) => {
            const userCount = params.data?.users?.length || 1;
            const baseHeight = 70;
            const perLineHeight = 22;
            return baseHeight + (userCount - 1) * perLineHeight;
          }}
          // getRowClass={(params) =>
          //   params.data.user_group_name === selectedRow ? "bg-gray-200" : ""
          // }
          getRowClass={(params) =>
            params.data?.user_group_name === selectedRow ? 'selected-row' : ''
          }

        />
      </div>

          </div>
  );
};

export default UserGroupTable;
